// MS-1 — Landing scaffolding.
// Shared width/spacing container for the public landing sections.
// Purely structural: no copy, no CTA logic, no new capability.
export const LandingSection = ({
  as: Tag = "section",
  className = "",
  innerClassName = "",
  children,
  ...rest
}) => (
  <Tag className={`w-full ${className}`} {...rest}>
    <div className={`mx-auto w-full max-w-7xl px-6 lg:px-8 ${innerClassName}`}>
      {children}
    </div>
  </Tag>
);
